import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Suppress harmless cross-origin 'Script error.' from the TradingView embed
// (the script itself is fine — only the React dev-overlay catches it and blocks clicks).
if (typeof window !== "undefined") {
  const isCrossOriginScriptErr = (msg, src) =>
    msg === "Script error." || (typeof src === "string" && src.includes("tradingview"));
  window.addEventListener(
    "error",
    (e) => {
      if (isCrossOriginScriptErr(e.message, e.filename)) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    },
    true,
  );
  window.addEventListener(
    "unhandledrejection",
    (e) => {
      const msg = e.reason && (e.reason.message || String(e.reason));
      if (msg && msg.includes("tradingview")) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    },
    true,
  );
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
